// extracted by mini-css-extract-plugin
export default {"wrapper":"src-containers-layouts-content-header-styles-wrapper-SwPOS"};